import type { Currency } from "stores/localeStore";

const localeByCurrency: Record<Currency, string> = {
  SEK: "sv-SE",
  DKK: "da-DK",
  NOK: "nb-NO",
};

export function formatCurrencyAmount(amount: number, currency: Currency): string {
  return new Intl.NumberFormat(localeByCurrency[currency], {
    style: "currency",
    currency,
  }).format(amount);
}

/** For table cells: missing or non-finite amounts render as an em dash. */
export function formatCurrencyAmountOrDash(
  amount: number | null | undefined,
  currency: Currency,
): string {
  if (amount == null || !Number.isFinite(amount)) return "—";
  return formatCurrencyAmount(amount, currency);
}
